/*
 * @Author: 张玉婷
 * @Date: 2022-03-07 18:03:43
 * @LastEditTime: 2022-11-22 11:28:12
 * @LastEditors: PanYunhong
 * @Description:
 * @FilePath: \air2.0-frontend\src\utils\AMap\infoWindow\index.ts
 */

export default class PopupWindow extends AMap.InfoWindow<any> {
  constructor (content: HTMLElement, offset: number[] = [0,0,]) {
    super({
      isCustom: true,
      // autoMove: true,
      content,
      anchor: 'top-left',
      offset: new AMap.Pixel(...offset),
    });
  }

  setPupPostion (map: any ,data: any): void {
    if (data) {
      this.open(map,[data?.lon, data?.lat,]);
    }
  }
}
